import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

interface Props {
    isAllowed: boolean;
    redirectPath: string;
}

// Carries the query string across the redirect: another app sends people to the root, not
// to `/login`, and the params (e.g. `?alerte=...`) must survive the bounce to the form.
const ProtectedRoute = ({ isAllowed, redirectPath }: Props) => {
    const location = useLocation();

    return isAllowed ? <Outlet /> : <Navigate to={{ pathname: redirectPath, search: location.search }} replace />;
};

export default ProtectedRoute;
